<template>
  <div class="search-wrapper">
    <div class="material-icons search-icon">search</div>
    <input
      type="text"
      id="search-input"
      @input="$_searchValues()"
      v-model="searchQuery"
      :placeholder="placeholder"
    />
    <button
      class="btn-floating waves-effect transparent z-depth-0 close-btn"
      v-if="searchQuery !== ''"
      @click="clearInput()"
    >
      <i class="material-icons grey-text text-darken-4">close</i>
    </button>
  </div>
</template>
<script>
const debounce = (func, delay) => {
  let inDebounce;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => func.apply(context, args), delay);
  };
};
export default {
  name: "searchBar",
  props: {
    placeholder: {
      type: String,
      default: "Search",
    },
  },
  data() {
    return {
      searchQuery: "",
    };
  },
  methods: {
    $_searchValues: debounce(function() {
      this.$emit("search", this.searchQuery);
    }, 150),
    clearInput() {
      this.searchQuery = "";
      this.$emit("search", "");
    },
  },
};
</script>
<style lang="scss">
.search-wrapper {
  display: flex;
  align-items: center;
  background: #a1a1a128;
  border-radius: 5px;
  position: relative;
  margin-bottom: 24px;
  .search-icon {
    padding: 0 1rem;
    color: #575555;
    position: absolute;
  }
  #search-input {
    margin: 0px;
    padding-left: 3.2rem;
    border: none !important;
    border-radius: 5px;
    input {
      background-color: #f1f3f4;
    }

    &:focus {
      background-color: #fff;
      box-shadow: 0 1px 1px 0 rgba(65, 69, 73, 0.3),
        0 1px 3px 1px rgba(65, 69, 73, 0.15);
    }
  }
  .close-btn {
    position: absolute;
    right: 8px;
    top: 2px;
  }
}
</style>
